import requset from "./requset.js"
import store from "../store/index.js"

export function reserveRegUserPhone(data) {
    return requset({
        url: "/reserve/reserve_reg_user_phone",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}

export function reserveUserNum(data) {
    return requset({
        url: "/reserve/reserve_user_num",
        method: "get",
        params: {
            site: store.state.site
        },
    })
}

export function reservePlayReserveUser(data) {
    return requset({
        url: "/reserve/play_reserve_user",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}

export function Reserveclick(data) {
    return requset({
        url: "/reserve/reserve_click",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}


export function ReserveGetPriceCode(data) {
    return requset({
        url: "/reserve/get_price_code",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}


export function ReserveGetPricelists(data) {
    return requset({
        url: "/reserve/price_lists",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}


export function ReserveGetAddToBrood(data) {
    return requset({
        url: "/reserve/addToBrood",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}


export function ReserveGetToBroodCount(data) {
    return requset({
        url: "/reserve/toBroodCount",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}

export function ReserveGetToBrood(data) {
    return requset({
        url: "/reserve/toBrood",
        method: "get",
        params: {
            ...data,
            site: store.state.site
        },
    })
}

export function reserveGetShare(params) {
    return requset({
        url: "/reserve/get_share",
        method: "get",
        params: {
            site: store.state.site,
            ...params
        },
    })
}